import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const addProductsToCatalogue = async ({ categoryId, body }) => {
  const path = `/mp_categories/${categoryId}/catalogue/`;
  try {
    const response = await axiosInstance.post(path, body);
    return response.data;
  } catch (error) {
    console.error('Add Products to Catalogue API error:', error);
    throw error;
  }
};

export const useAddProductsToMpCatalogue = (options = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: addProductsToCatalogue,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['mpCatalogues'] });
      queryClient.invalidateQueries({ queryKey: ['mpCategories'] });
      queryClient.invalidateQueries({
        queryKey: ['mpCategories', variables.categoryId],
      });

      options.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      options.onError?.(error, variables);
    },
    ...options,
  });

  return {
    addProductsToCatalogue: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
};
